export default "__VITE_ASSET__HsSskjjL__"